import React, { useEffect } from "react";
import "./SavingCalculator.css";
import { savingCalculator } from "../stepOneContent.js";

import {
  formControlStyle,
  inputLableStyle,
  outlineInputStyle,
  resultOutputStyle,
} from "../../../../../calculatorStyleData.js";
import {
  Button,
  Typography,
  FormControl,
  InputAdornment,
  OutlinedInput,
  Radio,
  RadioGroup,
  FormControlLabel,
  useMediaQuery,
} from "@mui/material";

import { useState } from "react";

const SavingCalculator = () => {
  // State for radio button

  // Separate states for inputs
  const [principal, setPrincipal] = useState(3000000); // Outstanding Principal Amount
  const [currentInterestRate, setCurrentInterestRate] = useState(10.25); // Current Interest Rate (%)
  const [currentTenure, setCurrentTenure] = useState(185); // Current Outstanding Tenure (Months)
  const [newInterestRate, setNewInterestRate] = useState(5); // Illustrative Interest Rate (%)
  const [newTenure, setNewTenure] = useState(240); // Required Tenure (Months)

  // Separate states for results
  const [currentEMI, setCurrentEMI] = useState(0); // Current Loan EMI
  const [newEMI, setNewEMI] = useState(0); // New Loan EMI
  const [totalPaidCurrent, setTotalPaidCurrent] = useState(0); // Total Paid for Current Loan
  const [totalPaidNew, setTotalPaidNew] = useState(0); // Total Paid for New Loan
  const [amountSaved, setAmountSaved] = useState(0); // Savings

  // State to track if the "Calculate" button has been clicked

  // Function to format numbers as Indian currency
  const formatter = (value) => {
    // Check if the value is a valid number
    if (isNaN(value) || value === undefined || value === null) {
      return "₹0"; // or any default value you want to return when the input is invalid
    }

    // Format the valid value
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  const formatCurrency = (value) => {
    return value.toLocaleString("en-IN");
  };

  const handleAmountChange = (e, setter) => {
    const value = e.target.value.replace(/,/g, ""); // Remove commas
    if (/^\d*\.?\d*$/.test(value)) {
      const numericValue = Number(value); // Convert to number
      if (numericValue <= 5000000) {
        // Restrict to maximum 50,00,000
        setter(numericValue);
      }
    }
  };
  // Function to calculate values when the "Calculate" button is clicked
  useEffect(() => {
    // EMI Calculation Formula
    const calculateEMI = (P, annualRate, N) => {
      const R = annualRate / (12 * 100); // Convert annual interest rate to monthly
      return (P * R * Math.pow(1 + R, N)) / (Math.pow(1 + R, N) - 1);
    };

    // Perform calculations and update output states
    const calculateResults = () => {
      // Calculate Current Loan EMI and Total Paid
      const emiCurrent = calculateEMI(
        principal,
        currentInterestRate,
        currentTenure
      );
      const totalCurrent = emiCurrent * currentTenure;

      // Calculate New Loan EMI and Total Paid
      const emiNew = calculateEMI(principal, newInterestRate, newTenure);
      const totalNew = emiNew * newTenure;

      // Calculate Savings
      const savings = totalCurrent - totalNew;

      // Update states
      setCurrentEMI(emiCurrent);
      setNewEMI(emiNew);
      setTotalPaidCurrent(totalCurrent);
      setTotalPaidNew(totalNew);
      setAmountSaved(savings);
    };

    // Call the calculateResults function
    calculateResults();
  }, [
    principal,
    currentInterestRate,
    currentTenure,
    newInterestRate,
    newTenure,
  ]);

  const isSmallScreen = useMediaQuery("(max-width:576px)");

  return (
    <>
      <div className="saving_calculator  ">
        <div className="saving_calculator_content">
          <div className="">
            <div className="saving_calculator_header mb-3">
              <Typography
                sx={{
                  fontSize: {
                    xs: "22px",
                    sm: "24.4312px",
                    md: "30.2752px",
                    lg: "35.1927px",
                  },
                  fontWeight: 600,
                  fontFamily: "'Archivo',sans-serif",
                }}
                className="saving_calculator_title  "
              >
                {savingCalculator[0].title}
              </Typography>
              <Typography
                sx={{
                  fontFamily: "'Archivo', sans-serif",
                  fontSize: "16px",
                  lineHeight: "24px",
                  letterSpacing: "normal",
                  textAlign: "start",
                  color: "#1F1F1F",
                }}
              >
                {savingCalculator[0].description}
              </Typography>
            </div>

            <div className="line"></div>

            <div className="saving_calculator_details mt-3">
              <div className="card_debt_heading">
                <Typography
                  sx={{
                    fontFamily: "'Archivo', sans-serif",
                    fontSize: "24px",
                    lineHeight: "28px",
                    letterSpacing: "normal",
                    textAlign: "start",
                    color: "#1F1F1F",
                    fontWeight: 700,
                  }}
                  className=""
                >
                  {savingCalculator[1].inputsHeadingOne}
                </Typography>
              </div>
              <div className="card_debt d-flex justify-content-between gap-3 mt-3 flex-column flex-md-row">
                <div className="d-flex flex-column gap-3">
                  <div className="new_card  w-100">
                    <label>
                      <Typography sx={inputLableStyle}>
                        Outstanding Loan Amount (₹):
                      </Typography>
                    </label>

                    <FormControl fullWidth sx={formControlStyle}>
                      <OutlinedInput
                        sx={outlineInputStyle}
                        id="outlined-adornment-amount"
                        fullWidth
                        size="small"
                        startAdornment={
                          <InputAdornment position="start">
                            <span className="archivo">&#8377;</span>
                          </InputAdornment>
                        }
                        value={formatCurrency(principal)} // Display value with commas
                        onChange={(e) => handleAmountChange(e, setPrincipal)}
                      />
                    </FormControl>
                  </div>
                  <div className="current_card  w-100">
                    <label className="table_font">
                      <Typography sx={inputLableStyle}>
                        Current Interest Rate (APR %){" "}
                      </Typography>
                    </label>

                    <FormControl fullWidth sx={formControlStyle}>
                      <OutlinedInput
                        sx={outlineInputStyle}
                        id="outlined-adornment-amount"
                        fullWidth
                        size="small"
                        endAdornment={
                          <InputAdornment position="start">
                            <span className="archivo">%</span>
                          </InputAdornment>
                        }
                        value={currentInterestRate || 0}
                        onChange={(e) => {
                          let value = e.target.value.replace(/,/g, ""); // Remove commas

                          if (/^\d*\.?\d*$/.test(value)) {
                            if (value === "") {
                              setCurrentInterestRate(""); // Allow empty field temporarily
                            } else {
                              setCurrentInterestRate(
                                value.replace(/^0+/, "") || "0"
                              ); // Remove leading zero
                            }
                          }
                        }}
                        onFocus={() =>
                          currentInterestRate === "0" &&
                          setCurrentInterestRate("")
                        } // Empty field on focus
                        onBlur={() =>
                          setCurrentInterestRate(
                            currentInterestRate === ""
                              ? "0"
                              : currentInterestRate
                          )
                        }
                      />
                    </FormControl>
                  </div>
                </div>
                <div className="d-flex flex-column gap-3">
                  <div className="number_of_months  w-100">
                    <label className="table_font fw-bold">
                      <Typography sx={inputLableStyle}>
                        Current Outstanding Tenure(Months):{" "}
                      </Typography>
                    </label>
                    <FormControl fullWidth sx={formControlStyle}>
                      <OutlinedInput
                        sx={outlineInputStyle}
                        id="outlined-adornment-amount"
                        fullWidth
                        size="small"
                        // value={inputs.repaymentPeriod}
                        // onChange={handleChange}
                        value={currentTenure}
                        onChange={(e) =>
                          handleAmountChange(e, setCurrentTenure)
                        }
                      />
                    </FormControl>
                  </div>
                </div>
              </div>
              <div className=" ">
                <div className="transfer_card_heading pt-3">
                  <p className="table_font">
                    {savingCalculator[1].inputsHeadingTwo}
                  </p>
                </div>
                <div className="transfer_card_inputs d-flex justify-content-between gap-3 mt-3 flex-column flex-md-row">
                  <div className="transfer_fee  w-100">
                    <label className="table_font fw-bold">
                      <Typography sx={inputLableStyle}>
                        New Interest Rates (%):{" "}
                      </Typography>
                    </label>
                    <FormControl fullWidth sx={formControlStyle}>
                      <OutlinedInput
                        sx={outlineInputStyle}
                        id="outlined-adornment-amount"
                        fullWidth
                        size="small"
                        endAdornment={
                          <InputAdornment position="start">
                            <span className="archivo">%</span>
                          </InputAdornment>
                        }
                        value={newInterestRate || 0}
                        onChange={(e) => {
                          let value = e.target.value.replace(/,/g, ""); // Remove commas

                          if (/^\d*\.?\d*$/.test(value)) {
                            if (value === "") {
                              setNewInterestRate(""); // Allow empty field temporarily
                            } else {
                              setNewInterestRate(
                                value.replace(/^0+/, "") || "0"
                              ); // Remove leading zero
                            }
                          }
                        }}
                        onFocus={() =>
                          newInterestRate === "0" && setNewInterestRate("")
                        } // Empty field on focus
                        onBlur={() =>
                          setNewInterestRate(
                            newInterestRate === "" ? "0" : newInterestRate
                          )
                        }
                      />
                    </FormControl>
                  </div>
                  <div className="number_of_months  w-100">
                    <label className="table_font fw-bold">
                      <Typography sx={inputLableStyle}>
                        Required Tenure (Months):
                      </Typography>
                    </label>
                    <FormControl fullWidth sx={formControlStyle}>
                      <OutlinedInput
                        sx={outlineInputStyle}
                        id="outlined-adornment-amount"
                        fullWidth
                        size="small"
                        // value={inputs.repaymentPeriod}
                        // onChange={handleChange}
                        value={newTenure}
                        onChange={(e) => handleAmountChange(e, setNewTenure)}
                      />
                    </FormControl>
                  </div>
                </div>
              </div>
              <div className="mt-5">
                <Typography
                  sx={{
                    fontFamily: "'Archivo',sans-serif",
                    fontWeight: 700,
                    fontSize: "24px",
                    color: "#820082",
                  }}
                >
                  Result:
                </Typography>
              </div>{" "}
            </div>
          </div>
          {/* Results data */}

          {/* {isCalculated && ( */}
          <div
            className="d-flex flex-column  justify-content-between gap-3 w-100"
            style={{ marginTop: "20px" }}
          >
            <div className="months d-flex flex-column flex-lg-row gap-3 mt-md-4">
              <div>
                <Typography
                  sx={{
                    fontFamily: "'Archivo', sans-serif",
                    fontSize: "18px",
                    fontWeight: 700,
                  }}
                >
                  Amount You Save:-
                </Typography>
              </div>
              <div>
                {/* style={{ paddingLeft: isSmallScreen ? "130px" : "0px" }} */}
                <Typography
                  sx={{
                    fontFamily: "'Archivo', sans-serif",
                    fontSize: "24px",
                    lineHeight: "24px",
                    letterSpacing: "normal",
                    textAlign: "start",
                    fontWeight: 700,
                    color: "#009964",
                  }}
                  className=" text-break"
                >
                  {formatter(amountSaved)}{" "}
                </Typography>
              </div>
            </div>
            <div className="months-one">
              <Typography
                sx={{
                  fontFamily: "'Archivo', sans-serif",
                  fontSize: "18px",
                  fontWeight: 700,
                }}
              >
                Monthly EMI:-{" "}
              </Typography>
              <div
                style={{ width: isSmallScreen ? "100%" : "85.5%" }}
                id="emi"
                className="d-flex flex-column flex-lg-row justify-content-between mt-2 px-3 gap-3"
              >
                <div className="d-flex flex-column flex-lg-row gap-2 px-lg-4 ">
                  <Typography
                    sx={{
                      fontFamily: "'Archivo',sans-serif",
                      fontSize: {
                        xs: "16px",
                        md: "13px",
                      },
                      textAlign: "start",
                    }}
                  >
                    Current Loan:
                  </Typography>
                  <Typography sx={resultOutputStyle}>
                    {formatter(currentEMI)}
                  </Typography>
                </div>
                <div className="d-flex flex-column flex-lg-row gap-2">
                  <Typography
                    sx={{
                      fontFamily: "'Archivo',sans-serif",
                      fontSize: {
                        xs: "16px",
                        md: "13px",
                      },
                      textAlign: "start",
                    }}
                  >
                    New Loan:
                  </Typography>
                  <Typography sx={resultOutputStyle}>
                    {formatter(newEMI)}
                  </Typography>
                </div>
              </div>
            </div>
            <div className="months-two mt-3">
              <Typography
                sx={{
                  fontFamily: "'Archivo', sans-serif",
                  fontSize: "18px",
                  fontWeight: 700,
                }}
              >
                Total Amount Paid:-{" "}
              </Typography>
              <div
                id="emi"
                style={{ width: isSmallScreen ? "100%" : "90%" }}
                className="d-flex flex-column flex-lg-row justify-content-between mt-2 px-3 gap-3 "
              >
                <div className="d-flex flex-column flex-lg-row gap-2 px-lg-4">
                  <Typography
                    sx={{
                      fontFamily: "'Archivo',sans-serif",
                      fontSize: {
                        xs: "16px",
                        md: "13px",
                      },
                      textAlign: "start",
                    }}
                  >
                    Current Loan:
                  </Typography>
                  <Typography sx={resultOutputStyle}>
                    {formatter(totalPaidCurrent)}
                  </Typography>
                </div>
                <div className="d-flex flex-column flex-lg-row gap-2">
                  <Typography
                    sx={{
                      fontFamily: "'Archivo',sans-serif",
                      fontSize: {
                        xs: "16px",
                        md: "13px",
                      },
                      textAlign: "start",
                    }}
                  >
                    New Loan:
                  </Typography>
                  <Typography sx={resultOutputStyle}>
                    {formatter(totalPaidNew)}
                  </Typography>
                </div>
              </div>
            </div>
          </div>

          {/* )} */}
        </div>
      </div>
    </>
  );
};

export default SavingCalculator;
